export const appVersion = 'ai@v2026.11.01.2320-820e5005';
